import { MatchConfigTypeToConfigKeyMap } from '@nova/configs';
import { EGameConfigs } from '@nova/types';

import { axiosHttp } from '../axios-http';

/** Server-side / MMS: unauthenticated `axiosHttp` (browser game API uses `GameApiHttp` elsewhere). */
export async function fetchCombatGameMatchConfigs(gameAPIEndpoint: string): Promise<MatchConfigTypeToConfigKeyMap> {
  try {
    const url = `${gameAPIEndpoint}/game-configs/${EGameConfigs.COMBAT_GAME_MAPS}`;
    const matchConfigsResponse = await axiosHttp.get(url);
    return matchConfigsResponse.data as MatchConfigTypeToConfigKeyMap;
  }
  catch (reason: unknown) {
    throw new Error(`LobbyMatchPrep::fetchCombatGameMatchConfigs error: ${reason}`, { cause: reason });
  }
}
